export default __webpack_public_path__ + "app/resources/icons.png";